import { motion } from "framer-motion";
import { Phone, Zap } from "lucide-react";

export default function StormCTA({ content }) {
  return (
    <section className="relative py-14" data-testid="storm-cta-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="relative overflow-hidden rounded-3xl border border-gold/30 bg-gradient-to-br from-storm-800 via-storm-800/90 to-storm p-8 sm:p-14"
        >
          <div className="absolute -top-24 -right-24 w-80 h-80 rounded-full bg-gold/15 blur-[100px]" />
          <div className="relative flex flex-col lg:flex-row lg:items-center gap-8 justify-between">
            <div className="max-w-2xl">
              <div className="inline-flex items-center gap-2 mb-4" data-testid="storm-status">
                <span className="relative flex h-2.5 w-2.5">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-gold opacity-60" />
                  <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-gold" />
                </span>
                <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-gold">24/7 dispatch active</span>
              </div>
              <h2 className="font-display font-bold italic uppercase text-3xl sm:text-5xl text-white leading-[0.95]" data-testid="storm-title">
                {content.storm_title}
              </h2>
              <p className="mt-4 text-slate-400 text-base sm:text-lg leading-relaxed" data-testid="storm-text">
                {content.storm_text}
              </p>
            </div>
            <div className="flex flex-col sm:flex-row lg:flex-col gap-3 shrink-0">
              <a href={`tel:${content.phone_tel}`} data-testid="storm-call-button"
                className="inline-flex items-center justify-center gap-2 bg-gold text-storm font-bold px-8 py-4 rounded-full hover:bg-gold-light transition-colors text-lg">
                <Zap size={18} />
                {content.phone_display}
              </a>
              <a href="#contact" data-testid="storm-inspection-button"
                className="inline-flex items-center justify-center gap-2 border border-gold/40 text-gold font-semibold px-8 py-4 rounded-full hover:bg-gold/10 transition-colors">
                <Phone size={16} />
                Free Inspection
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
